function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconForwardDeliveryAssignedError({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    height: 16,
    id: "screenshot-34d3a421-7580-800d-8006-026016da6084",
    viewBox: "0 0 16 16",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "shape-34d3a421-7580-800d-8006-026016da6084",
    width: 800,
    height: 800,
    rx: 0,
    ry: 0,
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "shape-34d3a421-7580-800d-8006-026016da6096",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-34d3a421-7580-800d-8006-026016da6096"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    x: 0,
    transform: "matrix(1.000000, 0.000000, 0.000000, 1.000000, 0.000000, 0.000000)",
    style: {
      fill: "rgb(255, 23, 23)",
      fillOpacity: 1
    },
    ry: 0,
    fill: "none",
    rx: 0,
    y: 0
  }))), /*#__PURE__*/React.createElement("g", {
    id: "shape-34d3a421-7580-800d-8006-026016da6097"
  }, /*#__PURE__*/React.createElement("g", {
    className: "fills",
    id: "fills-34d3a421-7580-800d-8006-026016da6097"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.000,8.000C0.000,9.088,0.213,10.123,0.640,11.104C1.067,12.085,1.632,12.939,2.336,13.664C3.040,14.389,3.893,14.960,4.896,15.376C5.899,15.792,6.933,16.000,8.000,16.000C9.067,16.000,10.101,15.792,11.104,15.376C12.107,14.960,12.960,14.389,13.664,13.664C14.368,12.939,14.933,12.085,15.360,11.104C15.787,10.123,16.000,9.088,16.000,8.000C16.000,6.912,15.787,5.877,15.360,4.896C14.933,3.915,14.368,3.061,13.664,2.336C12.960,1.611,12.112,1.045,11.120,0.640C10.128,0.235,9.088,0.021,8.000,0.000C6.912,0.000,5.877,0.213,4.896,0.640C3.915,1.067,3.061,1.632,2.336,2.336C1.611,3.040,1.045,3.893,0.640,4.896C0.235,5.899,0.021,6.933,0.000,8.000ZZM2.000,8.000C2.000,6.912,2.267,5.909,2.800,4.992C3.333,4.075,4.064,3.349,4.992,2.816C5.920,2.283,6.923,2.011,8.000,2.000C9.077,1.989,10.080,2.261,11.008,2.816C11.936,3.371,12.667,4.096,13.200,4.992C13.733,5.888,14.000,6.891,14.000,8.000C14.000,9.109,13.733,10.117,13.200,11.024C12.667,11.931,11.936,12.656,11.008,13.200C10.080,13.744,9.077,14.011,8.000,14.000C6.923,13.989,5.920,13.723,4.992,13.200C4.064,12.677,3.333,11.952,2.800,11.024C2.267,10.096,2.000,9.088,2.000,8.000ZZM6.000,5.008C6.000,5.339,6.085,5.835,6.256,6.496C6.427,7.157,6.592,7.744,6.752,8.256L7.008,9.008C7.008,9.285,7.104,9.520,7.296,9.712C7.488,9.904,7.723,10.000,8.000,10.000C8.277,10.000,8.512,9.904,8.704,9.712C8.896,9.520,8.997,9.285,9.008,9.008L10.000,5.008C10.000,4.453,9.803,3.979,9.408,3.584C9.013,3.189,8.544,2.997,8.000,3.008C7.456,3.019,6.987,3.211,6.592,3.584C6.197,3.957,6.000,4.432,6.000,5.008ZZM7.008,12.000C7.008,12.277,7.104,12.517,7.296,12.720C7.488,12.923,7.723,13.019,8.000,13.008C8.277,12.997,8.512,12.901,8.704,12.720C8.896,12.539,8.997,12.299,9.008,12.000C9.019,11.701,8.917,11.467,8.704,11.296C8.491,11.125,8.256,11.029,8.000,11.008C7.744,10.987,7.509,11.083,7.296,11.296C7.083,11.509,6.987,11.744,7.008,12.000ZZ",
    style: {
      fill: "rgb(255, 23, 23)",
      fillOpacity: 1
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconForwardDeliveryAssignedError);
export default __webpack_public_path__ + "static/media/icon-forward-delivery-assigned-error.aaf693b7b7cdfc41d570aaa144274e47.svg";
export { ForwardRef as ReactComponent };